'use strict';
module.exports = function (url, options) {
    if (!options) {
        options = {};
    }
    if (!url) {
        return url;
    }
    url = String(url.__esModule ? url['default'] : url);
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    if (options.hash) {
        url += options.hash;
    }
    if (/["'() \t\n]|(%20)/.test(url) || options.needQuotes) {
        return '"'.concat(url.replace(/"/g, '\\"').replace(/\n/g, '\\n'), '"');
    }
    return url;
};